import { render, staticRenderFns } from "./MinimizeIcon.vue?vue&type=template&id=fb33f2a0&"
import script from "./MinimizeIcon.vue?vue&type=script&lang=js&"
export * from "./MinimizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports